import React from 'react'
import Coordinator from './components/Coordinator'
import { useHistory } from 'react-router-dom'

const NewUserPage = ({ newUserType }) => {
  const history = useHistory()

  if (!newUserType) {
    return null
  }

  const NewUserToRender = () => {
    if (newUserType == 'project-manager') {
      return <Coordinator/>
    } else {
      history.push('/dashboard')
      return null
    }
  }

  return (
    <div className="w-full h-full flex flex-col">
      <div className="grow flex justify-between overflow-scroll">
        <div className="w-11/12 md:w-9/12 lg:2/3 xl:w-1/2 m-auto py-20">
          <NewUserToRender/>
        </div>
      </div>
    </div>
  )
}

export default NewUserPage
